
import { queryClient } from 'index';
import { getRecaptchaToken, DELETE, POST, GET } from './http-service';
import { useMutation, useQuery } from 'react-query';
import { isObjectEmpty } from 'utils';

export function Appointment({ journeyGuid: identity, processGuid, lngCode, rcaEnabled, executeRecaptcha, clientStateData, customerGUID: customerGuidFromJWT, useMock }) {

  const baseApi = `${lngCode}/appointments`;

  return {
    useSetAppointmentRegular() {
      return useMutation({
        mutationFn: async (data) => {
          if (useMock) {
            return Promise.resolve(() => {
              return {
                processGuid: '00000000-0000-0000-0000-00000000',
                serviceName: '',
                unitName: ''
              }
            })
          }

          const { serviceIds, date, appointmentStartTime, appointmentTypeId, questionAnswerDict, hasRecaptcha } = data;
          const params = {}

          if (serviceIds) params.serviceIds = serviceIds;
          if (date) params.date = date;
          if (lngCode) params.lngCode = lngCode;
          if (appointmentStartTime) params.appointmentStartTime = appointmentStartTime;
          if (appointmentTypeId) params.appointmentTypeId = appointmentTypeId;
          if (!isObjectEmpty(questionAnswerDict)) params.questionAnswerDict = questionAnswerDict;
          if (!!identity) params.identity = identity;

          const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken(await executeRecaptcha('setAppointment')) };

          return POST(`${baseApi}/`, params, headers);
        }

      })
    },

    useSetAppointmentReschedule() {
      return useMutation({
        mutationFn: async (data) => {
          if (useMock) {
            return Promise.resolve(() => {
              return {
                processGuid: '00000000-0000-0000-0000-00000000',
                serviceName: '',
                unitName: ''
              }
            })
          }
          const { serviceIds, date, appointmentStartTime, appointmentTypeId, questionAnswerDict, hasRecaptcha } = data;
          const params = {}

          if (serviceIds) params.serviceIds = serviceIds;
          if (date) params.date = date;
          if (lngCode) params.lngCode = lngCode;
          if (appointmentStartTime) params.appointmentStartTime = appointmentStartTime;
          if (appointmentTypeId) params.appointmentTypeId = appointmentTypeId;
          if (!isObjectEmpty(questionAnswerDict)) params.questionAnswerDict = questionAnswerDict;
          if (processGuid) params.processGuid = processGuid;
          if (!!identity) params.identity = identity;

          const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken(await executeRecaptcha('setAppointment')) };

          return POST(`${baseApi}/reschedule`, params, headers);
        }

      })
    },

    useCancelAppointment() {
      return useMutation({
        mutationFn: async ({ journeyGUID, processGuid, cancelationReasonId, hasRecaptcha }) => {
          if (useMock) {
            return Promise.resolve(() => true)
          }
          const params = {}

          if (cancelationReasonId) params.cancelationReasonId = cancelationReasonId;

          const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken(await executeRecaptcha('cancelAppointment'))) || {};
          //we hare not send identity in cancel appointment because we are not using it in the backend
          return DELETE(`${baseApi}/${journeyGUID}/${processGuid}`, { params, headers });
        }

      })
    },

    useAppointmentDetailsQuery(hasRecaptcha, customerGUID, journeyGUID, serviceTypeId,unitId,appointmentTypeId,serviceId,calendarIds,selectedSlot,selectedDate, questionAnswerDict, { skip }) {
      return useQuery(
        ['active-query', 'appointmentDetails', lngCode, hasRecaptcha, customerGUID, journeyGUID, serviceTypeId,unitId,appointmentTypeId,serviceId,calendarIds,selectedSlot,selectedDate, questionAnswerDict],
        ({ queryKey }) => getAppointmentDetails(...queryKey.slice(3)),
        { enabled: !skip }
      );
    },

    useAppointmentSumInfoQuery(serviceTypeId, appointmentTypeId, serviceId, onSuccess) {
      return useQuery(
        ['active-query', 'appointmentSumInfo', lngCode, serviceTypeId, appointmentTypeId, serviceId],
        ({ queryKey }) => getAppointmentSumInfo(...queryKey.slice(3)),
        { onSuccess:onSuccess }
      )
    }
  }


  async function getAppointmentDetails(hasRecaptcha, customerGUID, journeyGUID, serviceTypeId,locationId,appointmentTypeId,serviceId,calendarIds,selectedSlot,selectedDate, questionAnswerDict) {
    if (useMock) {
      var dateAndTime = new Date();
      dateAndTime.setDate(dateAndTime.getDate() + 7);
      return Promise.resolve(() => {
        return {
          serviceName: 'Service',
          locationName: '123 Main St, Springfield, IL',
          customerName: 'John Doe',
          dateAndTime: dateAndTime.toISOString(),
          serviceTypeName: 'Service Type',
          appointmentTypeName: 'Appointment Type',
          currentEntityStatus: 0
        }
      })
    }
    const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken(await executeRecaptcha('appointmentDetails'))) || {};
    const params = {}

    if (!!identity) params.identity = identity;
    if (lngCode) params.lngCode = lngCode;
    if (!!processGuid) params.processGuid = processGuid
    const clientStateData = {}
    if (locationId) clientStateData.unitId = locationId;
    if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
    if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
    if (serviceId) clientStateData.serviceId = serviceId;
    if (calendarIds) clientStateData.calendarIds = calendarIds;
    if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
    if (selectedDate) clientStateData.selectedDate = selectedDate;

    if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;
    if (customerGUID) clientStateData.customerGUID = customerGUID || customerGuidFromJWT;
    if (clientStateData) params.clientStateData = clientStateData

    queryClient.invalidateQueries({ queryKey: ['active-query', 'customer-info'] });

    return POST(`${baseApi}/findappointmentdetails`, params, headers)
  }

  async function getAppointmentSumInfo(serviceTypeId, appointmentTypeId, serviceId) {
    if (useMock) {
      return Promise.resolve(() => {
        return {
          locationName: '123 Main St, Springfield, IL',
          appointmentTypeName: 'Appointment Type',
          serviceTypeName: 'Service Type',
          serviceName: 'Service'
        }
      })
    }
    const params = {};

    if (serviceTypeId) params.serviceTypeId = serviceTypeId;
    if (appointmentTypeId) params.appointmentTypeId = appointmentTypeId;
    if (serviceId) params.serviceId = serviceId;

    return GET(`${baseApi}/appointmentsuminfo/${identity}`, { params })
  }

}
